<template>
  <div class="md:tw-inline-block tw-relative">

    <button id="actionsMenuInviteButton" @click="isDropdownOpen = ! isDropdownOpen" class="cu-btn tw-relative tw-mb-1">
      <i class="fa fa-spinner fa-pulse tw-mr-1" v-show="isLoading"></i>
      Aktion
      <i class="fa fa-chevron-down tw-ml-1"></i>
    </button>

    <div id="myDropdown" style="min-width: 250px;"
         class="dropdown-content tw-bg-white tw-absolute tw-overflow-auto tw-z-20 tw-rounded-md tw-pt-2 tw-pb-2 tw-border tw-border-navbar-secondary tw-right-0"
         v-show="isDropdownOpen"
         v-closable="{
                exclude: ['#actionsMenuInviteButton'],
                handler: 'onClose'
            }"
    >
      <button type="button"
        class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
        data-toggle="modal" data-target="#edit-mail"
      >
        <span>Bearbeiten</span>
      </button>

      <hr class="tw-my-2 tw-mr-0 tw-ml-0">

      <div class="tw-flex tw-flex-wrap">
        <a :href="`/application/${mail.id}/user-rejected`"
           class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
        >
          Bewerber hat abgesagt
        </a>
        <a :href="`/application/${mail.id}/manual-rejected`"
           @click="confirmManualReject"
           class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
        >
          Bewerber nicht erreicht
        </a>
      </div>
      <a :href="`/application/${mail.id}/department/${department.id}/reject`"
         class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
      >
        Bewerbung ablehnen
      </a>

      <hr class="tw-my-2 tw-mr-0 tw-ml-0">

        <template v-if="[MailStatus.STATUS_PROBE, MailStatus.STATUS_INTERN, MailStatus.STATUS_USER_INVITED_INTERN].indexOf(mail.status) !== -1">
          <button
              @click="openTrialModal"
              class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black tw-text-black focus:tw-text-black tw-text-black focus:tw-text-black tw-text-black focus:tw-text-black"
          >Termin eintragen</button>
        </template>

        <template v-else>
          <div class="tw-inline-flex tw-px-4 tw-mb-1 tw-container tw-flex-wrap">
          <h2>Termin eintragen</h2>
          <div class="tw-w-full tw-mt-4">
            <bordered-input>
              <template #label>
                <label for="date_from">
                  <template v-if="[MailStatus.STATUS_PROBE, MailStatus.STATUS_INTERN, MailStatus.STATUS_USER_INVITED_INTERN].indexOf(mail.status) !== -1">
                    Datum Beginn
                  </template>
                  <template v-else>
                    Datum
                  </template>
                </label>
              </template>
              <template #input>
                <input id="date_from" type="date" v-model="dateFrom">
              </template>
            </bordered-input>

            <div class="tw-w-full tw-text-danger-primary tw-text-sm"
                 v-if="!! this.validationErrors.date_from && this.validationErrors.date_from.length > 0">
              {{ this.validationErrors.date_from[0] }}
            </div>

            <template v-if="[MailStatus.STATUS_PROBE, MailStatus.STATUS_INTERN, MailStatus.STATUS_USER_INVITED_INTERN].indexOf(mail.status) !== -1">
              <bordered-input classes="tw-mt-2">
                <template #label>
                  <label for="date_end">
                    Datum Ende
                  </label>
                </template>
                <template #input>
                  <input id="date_end" type="date" v-model="dateEnd">
                </template>
              </bordered-input>
            </template>

            <div class="tw-w-full tw-text-danger-primary tw-text-sm"
                 v-if="!! this.validationErrors.date_end && this.validationErrors.date_end.length > 0">
              {{ this.validationErrors.date_end[0] }}
            </div>
          </div>

          <div class="tw-flex tw-w-full tw-mt-2">
            <div class="tw-mr-2 tw-w-full">
              <bordered-input>
                <template #label>
                  <label for="start">Beginn</label>
                </template>
                <template #input>
                  <input type="text"
                         id="start"
                         placeholder="HH:mm"
                         v-model="timeStart"
                  >
                </template>
              </bordered-input>
            </div>

            <div class="tw-w-full">
              <bordered-input>
                <template #label>
                  <label for="end">Ende</label>
                </template>
                <template #input>
                  <input type="text"
                         id="end"
                         placeholder="HH:mm"
                         v-model="timeEnd"
                  >
                </template>
              </bordered-input>
            </div>
          </div>

          <div class="tw-flex tw-w-full tw-mt-2" v-if="[MailStatus.STATUS_ONLINE_MEETING].indexOf(mail.status) !== -1">
            <div class="tw-mr-2 tw-w-full">
              <bordered-input>
                <template #label>
                  <label for="inviteLink">Einladungslink</label>
                </template>
                <template #input>
                  <input type="text"
                         id="inviteLink"
                         placeholder="Einladungslink"
                         v-model="inviteLink"
                  >
                </template>
              </bordered-input>
            </div>
          </div>

          <div>
            <div class="tw-w-full tw-text-danger-primary tw-text-sm"
                 v-if="(!! this.validationErrors.hour_start && this.validationErrors.hour_start.length > 0) || (!! this.validationErrors.minute_start && this.validationErrors.minute_start.length > 0)">
              <span v-if="!! this.validationErrors.hour_start" v-text="this.validationErrors.hour_start[0]"></span>
              <span v-else-if="!! this.validationErrors.minute_start"
                    v-text="this.validationErrors.minute_start[0]"></span>
            </div>

            <div class="tw-w-full tw-text-danger-primary tw-text-sm"
                 v-if="(!! this.validationErrors.hour_ends && this.validationErrors.hour_ends.length > 0) || (!! this.validationErrors.minute_ends && this.validationErrors.minute_ends.length > 0)">
              <span v-if="!! this.validationErrors.hour_ends" v-text="this.validationErrors.hour_ends[0]"></span>
              <span v-else-if="!! this.validationErrors.minute_ends" v-text="this.validationErrors.minute_ends[0]"></span>
            </div>

            <div class="tw-w-full tw-text-danger-primary tw-text-sm"
                 v-if="!!this.validationErrors.invite_link && this.validationErrors.invite_link.length > 0">
              <span v-if="!! this.validationErrors.invite_link" v-text="this.validationErrors.invite_link[0]"></span>
            </div>
          </div>

          <div @click="triggerDateAction()" class="cu-btn tw-mt-2">Speichern</div>
          </div>
        </template>
    </div>
  </div>
</template>

<script>
import Radio from "../Radio";
import CheckBox from "../CheckBox";
import BorderedInput from "../BorderedInput";

const MailStatus = {
  STATUS_UNREAD: 1,
  STATUS_READ: 2,
  STATUS_TELKO: 3,
  STATUS_TALK: 4,
  STATUS_PROBE: 5,
  STATUS_HOLD: 6,
  STATUS_CONTRACT: 7,
  STATUS_EMPLOYED: 8,
  STATUS_DENIED: 9,
  STATUS_USER_REJECTED: 10,
  STATUS_USER_INVITED_TELKO: 11,
  STATUS_USER_INVITED_TALK: 12,
  STATUS_USER_INVITED_PROBE: 13,
  STATUS_DENIED_AFTER_APPOINTMENT: 14,
  STATUS_DENIED_CONTRACT: 15,
  STATUS_HIRED: 16,
  STATUS_AUTOMATIC_DENIED: 17,
  STATUS_AUTOMATIC_DENIED_NOT_REACHED: 18,
  STATUS_AUTOMATIC_REFUSED: 19,
  STATUS_USER_INVITED_PROBE_AND_HR_MADE_PROBE_CONTRACT: 20,
  STATUS_ARCHIVED: 21,
  STATUS_ONLINE_MEETING: 22,
  STATUS_USER_INVITED_ONLINE_MEETING: 23,
  STATUS_INTERN: 24,
  STATUS_USER_INVITED_INTERN: 25,
  STATUS_STOPPED: 26,
  STATUS_FAILED_TO_APPEAR: 27,
};

const MailDepartmentStatus = {
  STATUS_UNREAD: 'unread',
  STATUS_READ: 'read',
  STATUS_DENIED: 'denied',
  STATUS_INVITE_PHONE: 'invite phone',
  STATUS_INVITE_INTERVIEW: 'invite interview',
  STATUS_INVITE_TRIAL_WORK: 'invite trial work',
  STATUS_INVITE_INTERN: 'invite intern',
  STATUS_REINVITE_PHONE: 'reinvite phone',
  STATUS_REINVITE_INTERVIEW: 'reinvite interview',
  STATUS_REINVITE_TRIAL_WORK: 'reinvite trial work',
  STATUS_REINVITE_INTERN: 'reinvite intern',
  STATUS_USER_REJECTED: 'user rejected',
  STATUS_INVITED_PHONE: 'invited phone',
  STATUS_INVITED_INTERVIEW: 'invited interview',
  STATUS_INVITED_TRIAL_WORK: 'invited trial work',
  STATUS_INVITED_INTERN: 'invited intern',
  STATUS_REINVITED_PHONE: 'reinvited phone',
  STATUS_REINVITED_INTERVIEW: 'reinvited interview',
  STATUS_REINVITED_TRIAL_WORK: 'reinvited trial work',
  STATUS_REINVITED_INTERN: 'reinvited intern',
  STATUS_DENIED_AFTER_APPOINTMENT: 'denied after appointment',
  STATUS_HOLD: 'hold',
  STATUS_CONTRACT: 'contract',
  STATUS_DENIED_CONTRACT: 'denied contract',
  STATUS_HIRED: 'hired',
  STATUS_AUTOMATIC_DENIED: 'auto denied',
  STATUS_AUTOMATIC_DENIED_NOT_REACHED: 'not reached auto denied',
  STATUS_AUTOMATIC_REFUSED: 'auto refused',
  STATUS_FAILED_TO_APPEAR: 'failed to appear',
};

export default {
  components: {
    Radio,
    CheckBox,
    BorderedInput,
  },

  props: {
    mail: {
      required: true,
      type: Object,
    },
    department: {
      required: false,
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      isDropdownOpen: false,
      isLoading: false,
      csrfToken: null,
      MailStatus: MailStatus,
      MailDepartmentStatus: MailDepartmentStatus,

      dateFrom: null,
      dateEnd: null,
      timeStart: null,
      timeEnd: null,
      inviteLink: null,

      validationErrors: {},
    }
  },

  methods: {
    onClose() {
      this.isDropdownOpen = false;
    },
    confirmManualReject(event) {
      if (!confirm('Möchten Sie diese Bewerbung wirklich ablehnen? Hierbei wird direkt eine Absage-E-Mail an den Bewerber gesendet.')) {
        event.preventDefault();
      }
    },
    openTrialModal() {
      this.isDropdownOpen = false;
      EventBus.$emit('set-trial-modal-is-invite', true);
      $('#trialModal').modal('show');
    },
    triggerDateAction() {
      this.isLoading = true;
      this.validationErrors = {};

      let hour_start = null;
      let minute_start = null;
      let hour_ends = null;
      let minute_ends = null;

      if (this.timeStart !== null) {
        let timeStartParts = this.timeStart.split(':');
        if (timeStartParts.length === 2) {
          hour_start = parseInt(timeStartParts[0]);
          minute_start = parseInt(timeStartParts[1]);
        }
      }

      if (this.timeEnd !== null) {
        let timeEndParts = this.timeEnd.split(':');
        if (timeEndParts.length === 2) {
          hour_ends = parseInt(timeEndParts[0]);
          minute_ends = parseInt(timeEndParts[1]);
        }
      }

      let data = {
        mail_id: this.mail.id,
        current_department_id: this.department.id,
        invite_link: this.inviteLink,

        date_from: this.dateFrom,

        hour_start: hour_start,
        minute_start: minute_start,

        hour_ends: hour_ends,
        minute_ends: minute_ends,
      };

      if (this.dateEnd !== null) data.date_end = this.dateEnd;

      axios.post('/application-invite-info', data)
          .then(response => {
            this.isLoading = false;
            window.location = '/applications/inbox/invite';
          })
          .catch(error => {
            if (!!error.response.data.errors) {
              this.validationErrors = error.response.data.errors;
            }
          })
          .then(() => {
            this.isLoading = false;
          });
    }
  },

  mounted() {
    this.csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;
  }
}
</script>